<template>
  <div
    v-if="isLoading"
    class="skeleton-usage-panel mb-3"
  >
    <RevisionsSkeletonLoader />
    <EngagementSkeletonLoader />
  </div>
</template>

<script>

import RevisionsSkeletonLoader from '@/components/shared/SkeletonLoaders/usage/RevisionsSkeletonLoader.vue';
import EngagementSkeletonLoader from '@/components/shared/SkeletonLoaders/usage/EngagementSkeletonLoader.vue';

export default {
  name: 'UsagePanelSkeletonLoader',
  components: {
    EngagementSkeletonLoader,
    RevisionsSkeletonLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/less/mixins';

.skeleton-usage-panel {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 336px;
}
</style>
